import React, { useState } from 'react';
import '../../../../assests/css/admin/DisputeManagement/DisputeList/DisputeList.css';

const DisputeList = ({ disputes, onViewDetails }) => {
  const [searchQuery, setSearchQuery]       = useState('');
  const [filterCategory, setFilterCategory] = useState('All Reasons');
  const [filterStatus, setFilterStatus]     = useState('Status: All');
  const [currentPage, setCurrentPage]       = useState(1);
  const [showReasonDropdown, setShowReasonDropdown] = useState(false);
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const itemsPerPage = 10;

  const reasons  = ['All Reasons', 'Damaged Item', 'Not Received', 'Size Mismatch', 'Missing Accessory'];
  const statuses = ['Status: All', 'open', 'pending', 'escalated', 'closed'];

  const filteredDisputes = disputes.filter(dispute => {
    const search = searchQuery.toLowerCase();
    const matchesSearch =
      String(dispute.id).toLowerCase().includes(search)               ||
      String(dispute.Mlorder_id || '').toLowerCase().includes(search) ||
      (dispute.customer_name  || '').toLowerCase().includes(search)   ||
      (dispute.subject        || '').toLowerCase().includes(search)   ||
      (dispute.category       || '').toLowerCase().includes(search);

    const matchesReason = filterCategory === 'All Reasons' ||
      (dispute.category || '').includes(filterCategory);

    const matchesStatus = filterStatus === 'Status: All' ||
      (dispute.status || '').toLowerCase() === filterStatus.toLowerCase();

    return matchesSearch && matchesReason && matchesStatus;
  });

  const totalPages        = Math.ceil(filteredDisputes.length / itemsPerPage);
  const startIndex        = (currentPage - 1) * itemsPerPage;
  const paginatedDisputes = filteredDisputes.slice(startIndex, startIndex + itemsPerPage);

  const getStatusClass = (status) => {
    const map = {
      'open':      'Dispute-Admin-Dispute-status-open',
      'pending':   'Dispute-Admin-Dispute-status-pending',
      'escalated': 'Dispute-Admin-Dispute-status-escalated',
      'closed':    'Dispute-Admin-Dispute-status-resolved',
    };
    return map[(status || '').toLowerCase()] || '';
  };

  const getStatusLabel = (status) => {
    const map = {
      'open':      'OPEN',
      'pending':   'PENDING',
      'escalated': 'ESCALATED',
      'closed':    'CLOSED',
    };
    return map[(status || '').toLowerCase()] || (status || '').toUpperCase();
  };

  const getReasonIcon = (category) => {
    if (!category) return '📝';
    if (category.includes('Damaged'))      return '📦';
    if (category.includes('Not Received')) return '📭';
    if (category.includes('Size'))         return '📏';
    if (category.includes('Missing'))      return '🔍';
    return '📝';
  };

  const handleClearAll = () => {
    setSearchQuery('');
    setFilterCategory('All Reasons');
    setFilterStatus('Status: All');
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  return (
    <div className="Dispute-Admin-Dispute-list-container">

      {/* ── Filters ── */}
      <div className="Dispute-Admin-Dispute-filters">
        <div className="Dispute-Admin-Dispute-search-box">
          <svg className="Dispute-Admin-Dispute-search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16zM18 18l-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <input
            type="text"
            className="Dispute-Admin-Dispute-search-input"
            placeholder="Search by Dispute ID, Order ID, or Customer..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="Dispute-Admin-Dispute-dropdown-wrapper">
          <button
            className="Dispute-Admin-Dispute-filter-button"
            onClick={() => { setShowReasonDropdown(!showReasonDropdown); setShowStatusDropdown(false); }}
          >
            {filterCategory}
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          {showReasonDropdown && (
            <div className="Dispute-Admin-Dispute-dropdown-menu">
              {reasons.map((reason) => (
                <div key={reason} className="Dispute-Admin-Dispute-dropdown-item"
                  onClick={() => { setFilterCategory(reason); setShowReasonDropdown(false); }}>
                  {reason}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="Dispute-Admin-Dispute-dropdown-wrapper">
          <button
            className="Dispute-Admin-Dispute-filter-button"
            onClick={() => { setShowStatusDropdown(!showStatusDropdown); setShowReasonDropdown(false); }}
          >
            {filterStatus}
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          {showStatusDropdown && (
            <div className="Dispute-Admin-Dispute-dropdown-menu">
              {statuses.map((status) => (
                <div key={status} className="Dispute-Admin-Dispute-dropdown-item"
                  onClick={() => { setFilterStatus(status); setShowStatusDropdown(false); }}>
                  {status}
                </div>
              ))}
            </div>
          )}
        </div>

        <button className="Dispute-Admin-Dispute-clear-button" onClick={handleClearAll}>
          Clear All
        </button>
      </div>

      {/* ── Table ── */}
      <div className="Dispute-Admin-Dispute-table">
        <div className="Dispute-Admin-Dispute-table-header">
          <div>DISPUTE ID</div>
          <div>ORDER & CUSTOMER</div>
          <div>CATEGORY</div>
          <div>DESCRIPTION</div>
          <div>STATUS</div>
          <div>DATE</div>
          <div>ACTIONS</div>
        </div>

        <div className="Dispute-Admin-Dispute-table-body">
          {paginatedDisputes.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '30px', color: '#888' }}>
              No disputes found.
            </div>
          ) : (
            paginatedDisputes.map((dispute, index) => (
              <div
                key={dispute.id}
                className="Dispute-Admin-Dispute-table-row"
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                {/* Dispute ID */}
                <div>
                  <span className="Dispute-Admin-Dispute-id-link">#{dispute.id}</span>
                </div>

                {/* Order & Customer */}
                <div>
                  <div className="Dispute-Admin-Dispute-customer-name">
                    {dispute.customer_name || 'N/A'}
                  </div>
                  <div className="Dispute-Admin-Dispute-order-id">
                    Order #{dispute.Mlorder_id || 'N/A'}
                  </div>
                </div>

                {/* Category */}
                <div className="Dispute-Admin-Dispute-col-reason">
                  <span className="Dispute-Admin-Dispute-reason-icon">
                    {getReasonIcon(dispute.category)}
                  </span>
                  <span>{dispute.category || 'N/A'}</span>
                </div>

                {/* Description */}
                <div className="Dispute-Admin-Dispute-col-description">
                  {dispute.description || 'N/A'}
                </div>

                {/* Status */}
                <div>
                  <span className={`Dispute-Admin-Dispute-status-badge ${getStatusClass(dispute.status)}`}>
                    {getStatusLabel(dispute.status)}
                  </span>
                </div>

                {/* Date */}
                <div className="Dispute-Admin-Dispute-col-date">
                  {dispute.created_at
                    ? new Date(dispute.created_at).toLocaleDateString()
                    : 'N/A'}
                </div>

                {/* Actions */}
                <div className="Dispute-Admin-Dispute-col-actions">
                  <button
                    className="Dispute-Admin-Dispute-view-button"
                    onClick={() => onViewDetails(dispute)}
                  >
                    View Details
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M6 12l4-4-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </button>
                </div>

              </div>
            ))
          )}
        </div>
      </div>

      {/* ── Pagination ── */}
      <div className="Dispute-Admin-Dispute-pagination">
        <div className="Dispute-Admin-Dispute-pagination-info">
          Showing {filteredDisputes.length === 0 ? 0 : startIndex + 1} to {Math.min(startIndex + itemsPerPage, filteredDisputes.length)} of {filteredDisputes.length} results
        </div>
        <div className="Dispute-Admin-Dispute-pagination-buttons">
          <button
            className="Dispute-Admin-Dispute-pagination-button"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i + 1}
              className={`Dispute-Admin-Dispute-pagination-number ${currentPage === i + 1 ? 'active' : ''}`}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </button>
          ))}
          <button
            className="Dispute-Admin-Dispute-pagination-button"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            Next
          </button>
        </div>
      </div>

    </div>
  );
};

export default DisputeList;